import { AxiosResponse } from "axios";
import { api } from "../api";
import {
  EntityPreview,
  GlobalSearchResponse,
  SearchEntity,
} from "./search.types";

export const globalSearch = async (
  q: string
): Promise<GlobalSearchResponse> => {
  try {
    const response: AxiosResponse<GlobalSearchResponse> = await api.get(
      "/admin/content/search",
      { params: { q, limit: 5 } }
    );
    return response.data;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const getEntityPreview = async (
  entity: SearchEntity,
  id: number
): Promise<EntityPreview> => {
  try {
    const response: AxiosResponse<EntityPreview> = await api.get(
      "/admin/content/preview",
      { params: { entity, id } }
    );
    return response.data;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};
